import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateMessageNew'
})
export class DateMessageNewPipe implements PipeTransform {

  transform(value: any): string {
    let date = new Date(value);
    let currentDate = new Date();
    let oneWeekAgo = new Date();
    oneWeekAgo.setDate(currentDate.getDate() - 7);

    if (date.getDate() === currentDate.getDate()) {
      return `${date.getHours()}:${date.getMinutes()}`;
    } else if (date > oneWeekAgo) {
      let daysOfTheWeek = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
      return daysOfTheWeek[date.getDay()];
    } else {
      return `${this.zeroTransform(date.getMonth() + 1)}.${this.zeroTransform(date.getDate())}.${date.getFullYear()}`;
    }
  }

  zeroTransform(n: number) {
    return n < 10 ? `0${n}` : n;
  }
}
